import React from "./_snowpack/pkg/react.js";
import ReactDOM from "./_snowpack/pkg/react-dom.js";
import App from "./App.js";
import "./styles.css";
ReactDOM.render(/* @__PURE__ */ React.createElement(App, null), document.getElementById("app"));
if (void 0) {
  (void 0).accept();
}
